<!--
  Navegación unificada : Anterior  |  Lección X de Y  |  [Completar y continuar  ó  Siguiente]
  - El botón derecho muestra "Completar y continuar" cuando la actividad requiere validación
    y aún no ha sido completada (mismas condiciones que el botón original #btn-course).
  - Al hacer click en "Completar y continuar" se marca activityCompleted=true y el botón
    cambia automáticamente a "Siguiente" en la misma posición.
  - Si la actividad no requiere validación, aparece directamente "Siguiente".
-->
<!-- SECCION ANTERIOR -- COMPLETAR Y CONTINUAR -- SIGUIENTE -->

<div class="next-prev-nav mb-6 flex flex-col md:flex-row items-center justify-between gap-4 rounded-2xl border border-[#E8EAEF] bg-white px-6 py-4">

  <!-- Botón Anterior  -->
  <button
    type="button"
    class="next-prev-nav__btn inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#E8EAEF] text-sm font-semibold text-[#22304C] hover:bg-[#F6F7F9] transition-colors"
    (click)="goPrev()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="m12 19-7-7 7-7"></path>
      <path d="M19 12H5"></path>
    </svg>
    <span class="next-prev-nav__label">{{ 'word.previous' | translate }}</span>
  </button>

  <!-- Indicador "Lección X de Y" (lecciones reales del módulo actual) -->
  <span class="text-sm text-gray-500 next-prev-nav__counter">
    <span class="next-prev-nav__counter-label">{{ 'words.lesson' | translate }} </span>{{ getCurrentLessonIndex() }} de {{ getTotalLessons() }}
  </span>

  <!--
    Botón derecho: alterna entre "Completar y continuar" y "Siguiente".
    showCompleteButton(): true cuando la actividad necesita ser completada y aún no lo está.
  -->
  <ng-container *ngIf="showCompleteButton(); else nextBtnTpl">
    <!-- BOTÓN ORIGINAL #btn-course conservado: misma lógica (activityFinished, loading, display, refreshData) -->
    <button
      id="btn-course"
      type="button"
      class="next-prev-nav__btn inline-flex items-center gap-2 px-5 py-2.5 rounded-full border text-sm font-semibold text-white transition-colors"
      [style.background]="isSubmitDisabled() ? '#C7CDD6' : 'var(--secondary-color)'"
      [style.box-shadow]="isSubmitDisabled() ? 'none' : 'rgba(255, 45, 85, 0.25) 0px 20px 50px -20px'"
      [style.cursor]="isSubmitDisabled() ? 'not-allowed' : 'pointer'"
      [style.opacity]="isSubmitDisabled() ? '0.7' : '1'"
      [disabled]="isSubmitDisabled()"
      (click)="activityFinished()"
    >
      <div class="lds-ring" *ngIf="loading">
        <div></div><div></div><div></div><div></div>
      </div>

      <!-- Check solo en mobile -->
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
        class="next-prev-nav__icon-mobile w-4 h-4 text-white">
        <path d="M20 6 9 17l-5-5"></path>
      </svg>

      <ng-container *ngIf="display; else endActivityTemplate" (click)="refreshData()">
        <span class="next-prev-nav__label">{{
          (type === "project" || type === "selfassessment"
            ? "player.common.submit-activity"
            : "player.common.continue-activity"
          ) | translate
        }}</span>
      </ng-container>

      <ng-template #endActivityTemplate>
        <span class="next-prev-nav__label">{{ "player.common.ended-activity" | translate }}</span>
      </ng-template>
    </button>
  </ng-container>

  <ng-template #nextBtnTpl>
    <!-- Botón Siguiente (nuevo): aparece cuando no se requiere completar la actividad o ya fue completada -->
    <button
      type="button"
      class="next-prev-nav__btn inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed"
      style="background: var(--primary-color); box-shadow: rgba(255, 45, 85, 0.25) 0px 20px 50px -20px;"
      [disabled]="isNextDisabled()"
      (click)="goNextNav()"
    >
      <span class="next-prev-nav__label">{{ 'word.next' | translate }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"></path>
        <path d="m12 5 7 7-7 7"></path>
      </svg>
    </button>
  </ng-template>
</div>

<style>
  /* Solo responsive — desktop intacto */
  .next-prev-nav__icon-mobile {
    display: none;
  }

  @media (max-width: 768px) {
    .next-prev-nav {
      flex-direction: row !important;
      gap: 0.5rem !important;
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }

    .next-prev-nav__label {
      display: none !important;
    }

    .next-prev-nav__counter-label {
      display: none !important;
    }

    .next-prev-nav__btn {
      padding-left: 0.75rem !important;
      padding-right: 0.75rem !important;
    }

    .next-prev-nav__icon-mobile {
      display: inline-block !important;
    }
  }
</style>
